import * as types from './types'

export const initOptionsAction = req => ({ type: types.GET_OPTIONS, req })
